import React from 'react';
import AppSettingsEditor, {
    AppSettingsSpecifiedControls,
} from 'appToolbar/AppSettingsEditor';
import { useTileInNewportSingleWidgetMode } from 'widgets/tiles/components/toolbar/hooks';
import { useSelectAppSettings } from 'app/store/appSettings/selectors';
import { useDispatchUpdateAppSettings } from 'app/store/appSettings/dispatcher';

export interface WidgetNewportAppSettingsEditorProps {
    specifyVisibleControls?: AppSettingsSpecifiedControls;
}

export default function WidgetNewportAppSettingsEditor(
    props: WidgetNewportAppSettingsEditorProps
) {
    const isNewportSingleWidget = useTileInNewportSingleWidgetMode();
    const appSettings = useSelectAppSettings();
    const dispatchUpdateAppSettings = useDispatchUpdateAppSettings();

    const { specifyVisibleControls: specifyVisibleControlsProps } = props;

    const specifyVisibleControls = specifyVisibleControlsProps || {
        symbology: true,
        showChartHelp: true,
        showTooltips: true,
    };

    if (!isNewportSingleWidget) {
        return <></>;
    }

    return (
        <div className="WidgetNewportAppSettingsEditor ">
            <AppSettingsEditor
                appSettings={appSettings}
                onAppSettingsChanged={dispatchUpdateAppSettings}
                specifyVisibleControls={specifyVisibleControls}
            />
        </div>
    );
}
